import { Col, Dropdown, Menu, Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import { Div, FormItem, Icon, Input, TagsTextArea } from 'ui';
import useDeepCompareEffect from 'use-deep-compare-effect';

const StyledInfo = styled.p`
  ${p => p.marginTop && `margin-top: ${p.marginTop}px;`}
  margin-left: 20px;
  color: rgba(100,116,124,0.85);
  font-weight: 400;
  font-size: 13px;
`;

const TextAreaFormItem = styled(FormItem)`
  margin-top: 40px;
  .ant-legacy-form-item-label {
    overflow: visible;
  }
  .ant-legacy-form-item-required::before {
    float: left;
    margin-top: 10px;
  }
`;

const TextAreaWrapper = styled(Div)`
  height: 100%;

  > textarea {
    height: 250px !important;
  }
`;

const StyledText = styled.span`
  float: left;
`;

const ActionMenu = styled(Menu)`
  text-transform: uppercase;
`;

const DownIcon = styled(Icon)`
  color: ${p => p.disabled ? 'rgba(0, 0, 0, 0.25)' : p.theme.colors.theme};
  cursor: ${p => p.disabled ? 'not-allowed' : 'pointer'} !important;
`;

const ActionDropdown = styled(Dropdown)`
  float: right;
  pointer-events: auto;
  &:hover, &:focus, &:active {
    ${p => p.disabled && 'color: rgba(0, 0, 0, 0.25) !important;'}
  }
`;

const GeneralTab = ({
  intl,
  form,
  tags,
  setIsTranslateModalVisible,
  ticketMessage,
  isLoadingAction,
  action,
  renderSaveButton,
  setDisabled,
  smartActionAutoClosed,
}) => {
  useDeepCompareEffect(() => {
    const description = form.getFieldValue('orderDescription');
    const note = form.getFieldValue('note');

    setDisabled(
      isLoadingAction ||
      !description ||
      description?.length > 40 ||
      !note,
    );
  }, [form.getFieldsValue(), isLoadingAction]);

  const copyTicketDescription = () => {
    const value = form.getFieldValue('note') ? `${form.getFieldValue('note')}
    <br />
    <br />
    <br />
    ${ticketMessage}` :
      ticketMessage;
    form.setFields({
      note: {
        value,
      },
    });
  };

  const actionMenu =
    <ActionMenu>
      <Menu.Item>
        <p onClick={() => setIsTranslateModalVisible(true)}>
          {`${intl.formatMessage({ id: 'ticket.smart_actions.TRANSLATE' })}...`}
        </p>
      </Menu.Item>
      <Menu.Item>
        <p onClick={() => copyTicketDescription()}>
          {intl.formatMessage({ id: 'ticket.smart_actions.INCLUDE_TICKET_DESCRIPTION' })}
        </p>
      </Menu.Item>
    </ActionMenu>;

  const renderLabel = () =>
    <>
      <StyledText>{intl.formatMessage({ id: 'ticket.smart_actions.NOTE_LABEL' })}</StyledText>
      <ActionDropdown
        overlay={actionMenu}
        disabled={isLoadingAction || action.orderId}
      >
        <a onClick={e => e.preventDefault()}>
          {intl.formatMessage({ id: 'ticket.smart_actions.ACTIONS' })}
          <DownIcon type='chevron-down' disabled={isLoadingAction || action.orderId} />
        </a>
      </ActionDropdown>
    </>;

  const descriptionValidator = form.getFieldDecorator('orderDescription', {
    rules: [
      { max: 40, message: intl.formatMessage({ id: 'rules.DESCRIPTION_40' }) },
      { required: true, message: intl.formatMessage({ id: 'rules.DESCRIPTION_GENERAL' }) },
    ],
    initialValue: action ? action?.description : '',
  });

  form.getFieldDecorator('originalNote', {
    initialValue: action ? action?.originalNote : '',
  });

  const noteValidator = form.getFieldDecorator('note', {
    rules: [
      { required: true, message: intl.formatMessage({ id: 'rules.NOTE_GENERAL' }) },
    ],
    initialValue: action ? action?.note : '',
  });

  return (
    <>
      <Row>
        <Col span={16}>
          <FormItem
            label={intl.formatMessage({
              id: 'ticket.smart_actions.ORDER_DESCRIPTION',
            })}
          >
            {descriptionValidator(
              <Input
                data-test-id='smart-action-order-description'
                disabled={isLoadingAction || action.orderId || smartActionAutoClosed}
              />,
            )}
          </FormItem>
        </Col>
        <Col span={8}>
          <StyledInfo marginTop={20}>
            {intl.formatMessage({ id: 'ticket.smart_actions.DESCRIPTION_INFO' })}
          </StyledInfo>
        </Col>
      </Row>
      <Row>
        <Col span={16}>
          <TextAreaFormItem
            className='comment-text'
            label={renderLabel()}
            colon={false}
          >
            <TextAreaWrapper data-test-id='smart-action-note-for-fse'>
              {noteValidator(<TagsTextArea
                tags={tags}
                disabled={isLoadingAction || action.orderId || smartActionAutoClosed}
              />)}
            </TextAreaWrapper>
          </TextAreaFormItem>
        </Col>
        <Col span={8}>
          <StyledInfo marginTop={30}>
            {intl.formatMessage({ id: 'ticket.smart_actions.NOTE_INFO' })}
          </StyledInfo>
          <StyledInfo marginTop={20}>
            {intl.formatMessage({ id: 'ticket.smart_actions.ACTION_INFO' })}
          </StyledInfo>
        </Col>
      </Row>
      {renderSaveButton()}
    </>
  );
};

GeneralTab.propTypes = {
  intl: PropTypes.object,
  form: PropTypes.object,
  tags: PropTypes.array,
  setIsTranslateModalVisible: PropTypes.func,
  ticketMessage: PropTypes.string,
  isLoadingAction: PropTypes.bool,
  action: PropTypes.object,
  renderSaveButton: PropTypes.func,
  setDisabled: PropTypes.func,
  smartActionAutoClosed: PropTypes.bool,
};
export default injectIntl(GeneralTab);
